// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pantone"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 10.333V19.9997L2 19.9997L2 10.333L22 10.333Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M20.8241 10.3333L19.0005 5L3.35349 10.3333L20.8241 10.3333Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M14.1461 1.43164L2.99902 10.3359L3.35349 10.3333L17.1429 5.63318L14.1461 1.43164Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3.35389 10.3333L20.8245 10.3333L19.0009 5L3.35389 10.3333ZM3.35389 10.3333L17.1433 5.63318L14.1465 1.43164L2.99942 10.3359M3.35389 10.3333L2.99942 10.3359M2.99942 10.3359H2.5","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M6.28516 15.1641H6.28906V15.168H6.28516V15.1641Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M22 10.333V19.9997L2 19.9997L2 10.333L22 10.333Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const PantoneIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pantone',
    ref,
    icon: element,
  },
));

PantoneIcon.displayName = 'PantoneIcon';

export default PantoneIcon;
